/** Features that still run on sample data, hidden from an alpha build by naming them in VITE_ALPHA_HIDDEN. */
export type AlphaFeature = 'opportunities' | 'xp' | 'admin-colleges' | 'admin-accounts' | 'code-challenges'

// Read once: Vite inlines the value at build time. Unknown names are harmless, since only known ones are asked for.
const hidden = new Set(
  String(import.meta.env.VITE_ALPHA_HIDDEN ?? '').split(',').map((name) => name.trim().toLowerCase()),
)

/** True when this build hides the feature. With VITE_ALPHA_HIDDEN unset or empty, nothing is hidden. */
export function featureHidden(name: AlphaFeature): boolean {
  return hidden.has(name)
}
